import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let date = new Date();
export default new Vuex.Store({
	state: {
		token: '',
		profile: null,
		loading: !1,//加载中
		pageSize: 20,//分页显示数量
		userGroupListAvailable: [],//群列表二级导航数据
		groupId: '',
		queryFlagList: [
			{id: '', name: '全部'},
			{id: 1, name: '未完成单据'},
			{id: 2, name: '今日单据'},
			{id: 3, name: '昨日单据'},
			{id: 4, name: '本周单据'},
			{id: 5, name: '上周单据'},
			{id: 6, name: '本月单据'},
			{id: 7, name: '上月单据'},
		]
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js